import apiClient from './apiClient';

export const emailVerificationApi = {
  verifyEmail: async (token, email) => {
    const response = await apiClient.get(`/auth/admin/verify-token/${token}/${email}`);
    return response.data;
  }
};
